// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"J1-z"};